<template>
  <div>
    <!-- loading -->
    <LoadingSpinner v-if="!loading" />
    <div v-else class="row">
      <div class="col-md-6">
        <div v-if="hasPermissions('superAdmin')" class="mb-3 user-client-select">
          <h5 class="ml-0 mr-2 mb-1 font-weight-bold">Client:</h5>
          <div class="position-relative">
            <treeselect
              :disabled="loadingClients"
              v-model="selectedClientId"
              :options="clientsForTreeselect"
              :normalizer="normalizeOptions"
              :match-keys="['label', 'searchId']"
              :searchable="true"
              :multiple="false"
              :clearable="false"
              :max-height="300"
              placeholder="Search by name or client ID..."
              @search-change="onClientSearchChange"
            />
            <small
              v-if="loadingClients"
              class="spinner-border loading-spinner user-client-select__spinner"
            ></small>
          </div>
          <small v-if="selected.client && selected.client.name" class="text-muted d-block mt-1">
            Current:
            <a :href="'/clients/' + selected.user.client_id" target="_blank">
              {{ selected.client.name }} (#{{ selected.user.client_id }})
            </a>
          </small>
        </div>

        <div v-if="!hasPermissions('isAgencyManager')">
          <h5 class="ml-0 mr-2 mb-1 font-weight-bold">Rol:</h5>
          <div>
            <select class="form-control" v-model="selected.user.role_id">
              <option v-if="selected.user.client_id != 4269" value="2">Admin</option>
              <option v-if="selected.user.client_id != 4269" value="3">Non-admin</option>
              <option v-if="selected.user.client_id != 4269" value="4">Billing</option>
              <option v-if="selected.user.client_id != 4269" value="5">Agency</option>
              <option v-if="selected.user.client_id != 4269" value="7">Referal</option>
              <option v-if="selected.user.client_id == 4269" value="1-1">Oliver Operational</option>
              <option v-if="selected.user.client_id == 4269" value="1-2">Account Manager</option>
              <option v-if="selected.user.client_id == 4269" value="1-3">Account Executive</option>
            </select>
          </div>
        </div>

        <div>
          <h5 class="my-2">
            <span class="mr-2"> Link Calendar : </span>
          </h5>
          <input type="text" v-model="selected.user.calendar_link" class="form-control" />
          <h5 class="my-2">
            <span class="mr-2"> Link Landing Page : </span>
          </h5>
          <input type="text" v-model="selected.user.landing_link" class="form-control" />
          <h5 class="my-2">
            <span class="mr-2"> Calendly Token : </span>
          </h5>
          <input type="text" v-model="selected.user.calendly" class="form-control" />
        </div>

        <div class="my-3">
          <div class="mx-auto p-2 card">
            <div class="mt-3">
              <div v-if="mygroups.length > 0">
                <h6 class="text-center font-weight-bold">My current groups</h6>
                <ul class="text-center">
                  <li v-for="group in mygroups">
                    {{ group.name }} -
                    {{ getRole(group.team_role_id) }}
                    <i class="icon-close text-danger cursor-pointer" @click="deleteMember(group.id)"></i>
                  </li>
                </ul>
              </div>
              <hr />
              <div v-if="!hasPermissions('isAgencyManager')">
                <h6 class="text-center">Assign Group</h6>
                <span class="mb-1">Select:</span>
                <select class="form-control mb-2" v-model="group" @change="selectGroup">
                  <option value="">-none-</option>
                  <option v-for="group in groups" :value="group.id">
                    {{ group.name }} ({{ group.client_id }})
                  </option>
                </select>
                <span class="mb-1" v-if="!group">Or create:</span>
                <input class="form-control mb-2" type="text" v-model="groupnew" />
              </div>
            </div>
            <div class="mb-3" v-if="group || groupnew">
              <strong class="mr-1">Rol</strong>
              <select class="form-control" v-model="group_role">
                <option value="2">
                  Project manager (all opportunities access)
                </option>
                <option value="3">
                  Viewer (only calendar opportunity access)
                </option>
                <option value="1">Member (own opportunities access)</option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-12 my-4" v-if="active || !selected.user.verificationcode">
          <div class="card p-4">
            <h5 class="my-2" v-if="!hasPermissions('isAgencyManager')">
              <span class="mr-2"> Account Verified </span>
              <i class="text-success icon-checkmark"></i>
            </h5>
            <div v-if="selected.user.login_attempt < 4">
              <div>
                <h5>
                  <span class="mr-2"> Account Active </span>
                  <i class="text-success icon-checkmark"></i>
                </h5>
                <small>Remaining attempts:
                  {{ 4 - selected.user.login_attempt }}
                </small>
              </div>
            </div>
            <div v-if="selected.user.login_attempt == 4">
              <div>
                <h5>
                  <span class="mr-2"> Account Blocked </span>
                  <i class="text-danger icon-close"></i>
                </h5>
                <small class="text-danger">( Account locked for repeated attempts )</small>
              </div>
              <button @click="unBlock()" class="mt-3 btn btn-sm btn-success">
                unblock
              </button>
            </div>
          </div>

        </div>

        <div class="col-md-12 my-4" v-if="!active && selected.user.verificationcode">
          <div class="card p-4">
            <h5 class="my-2">
              <span class="mr-2"> Account not verified yet. </span>
              <i class="text-danger icon-close"></i>
            </h5>
            <h5>
              Code verification
              <small class="ml-1">
                {{ selected.user.verificationcode }}
              </small>
            </h5>
            <button @click="approveVerification()" class="ml-1 btn btn-sm btn-primary">
              Force activation
              <i class="text-white icon-checkmark"></i>
            </button>
            <small class="ml-1"> active this account without verification.</small>
          </div>
        </div>

      </div>
      <div class="col-md-6  " v-if="selected.user.role_id == 5 || selected.user.role_id == 7">
        <h5 class="ml-0 mr-2 mb-1 font-weight-bold">
          <span class="mr-2"> Referral fee per client: </span>
        </h5>
        <input class="form-control mb-2" type="number" v-model="feeClient" />

        <h5 class="my-2">
          <span class="mr-2"> Revenue share (%): </span>
        </h5>
        <input class="form-control mb-2" type="number" v-model="renueShare" step="0.01" />

        <div class="form-group">
          <h5 class="my-1">
            <span class="mr-2">Affiliate compensation type:</span>
          </h5>

          <select class="form-control mb-2" id="affiliate_comp_type" name="affiliate_comp_type"
            v-model="affiliateCompType">
            <option value="" selected disabled>Select an option…</option>
            <option value="FIXED">Fixed fee per referred customer</option>
            <option value="REVENUE_SHARE">Commission on generated revenue</option>
            <option value="FIXED_PLUS_REVENUE">Both (fixed fee + commission)</option>
          </select>

          <small class="form-text text-muted">
            Choose how the affiliate’s compensation is calculated.
          </small>
        </div>

        <div class="form-group">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="checkDefault" v-model="timeComission">
            <label class="form-check-label" for="checkDefault">
              Only Comission 18 Months
            </label>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <button @click="saveUserClientDetail()" class="btn btn-primary w-25 font-weight-bold rounded-pill">
          {{ $t("lang.button.update") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { usersService, clientsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: {
    LoadingSpinner,
    Treeselect,
  },
  props: {
    selected: {
      type: Object,
    },
    selectedUserId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      group: false,
      groupnew: "",
      groups: [],
      mygroups: [],
      group_role: 1,
      active: false,
      feeClient: 0,
      renueShare: 0,
      affiliateCompType: null,
      timeComission: false,
      selectedClientId: null,
      clients: [],
      loadingClients: false,
      clientSearchQuery: "",
      clientSearchTimer: null,
    };
  },
  computed: {
    clientsForTreeselect() {
      var q = (this.clientSearchQuery || "").trim().toLowerCase();
      var options = [];

      if (!q) {
        options = this.clients.slice(0, 50);
      } else {
        var isNumericQuery = /^\d+$/.test(q);
        if (!isNumericQuery && q.length < 2) {
          options = [];
        } else {
          for (var i = 0; i < this.clients.length; i++) {
            var c = this.clients[i];
            var matchByName = c._search && c._search.indexOf(q) !== -1;
            var matchById = c.searchId && c.searchId.indexOf(q) !== -1;
            if (matchByName || matchById) {
              options.push(c);
              if (options.length >= 200) {
                break;
              }
            }
          }
        }
      }

      return this.withSelectedClientOption(options);
    },
  },
  created() {
    usersService.getAllGroupsByUser(this.$route.params.id).then((result) => {
      this.groups = result;
    });
    this.myGroups();
    if (this.hasPermissions("superAdmin")) {
      this.loadClients();
    }
  },

  mounted() {
    this.selectedClientId = this.normalizeClientId(this.selected.user.client_id);
    if (this.selected.user.role_id == 5 || this.selected.user.role_id == 7) {
      this.feeClient = this.selected.user.fixed_fee_amount;
      this.renueShare = this.selected.user.revenue_share_percent;
      this.affiliateCompType = this.selected.user.compensation_type
     
      this.timeComission = this.selected.user.commision_time == 1 ? true : false;
     
  
    }

  },
  methods: {
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    normalizeClientId(clientId) {
      if (clientId == null || clientId === "") {
        return null;
      }
      return Number(clientId);
    },
    buildClientOption(clientId, clientName) {
      var id = this.normalizeClientId(clientId);
      var name = clientName || "Client";
      return {
        id: id,
        label: "#" + id + " - " + name,
        searchId: String(id),
        _search: (name + " " + id).toLowerCase(),
      };
    },
    withSelectedClientOption(options) {
      var selectedId = this.normalizeClientId(this.selectedClientId);
      if (!selectedId) {
        return options;
      }

      var hasSelected = options.some(function (c) {
        return Number(c.id) === selectedId;
      });
      if (hasSelected) {
        return options;
      }

      var selectedOption = this.clients.find(function (c) {
        return Number(c.id) === selectedId;
      });
      if (!selectedOption) {
        var currentName = this.selected && this.selected.client ? this.selected.client.name : "";
        selectedOption = this.buildClientOption(selectedId, currentName);
      }

      return [selectedOption].concat(options);
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.label,
        searchId: node.searchId,
      };
    },
    onClientSearchChange(query) {
      var self = this;
      if (this.clientSearchTimer) {
        clearTimeout(this.clientSearchTimer);
      }
      this.clientSearchTimer = setTimeout(function () {
        self.clientSearchQuery = query || "";
      }, 200);
    },
    async loadClients() {
      this.loadingClients = true;
      try {
        var result = await clientsService.getAll();
        var list = Array.isArray(result)
          ? result
          : result && result.data
            ? result.data
            : [];
        this.clients = (Array.isArray(list) ? list : []).map((client) => {
          return this.buildClientOption(client.id, client.name || "");
        });
        var selectedId = this.normalizeClientId(this.selectedClientId);
        if (
          selectedId != null &&
          !this.clients.some((c) => Number(c.id) === selectedId)
        ) {
          var currentName = this.selected.client ? this.selected.client.name : "";
          this.clients.unshift(this.buildClientOption(selectedId, currentName));
        }
        this.selectedClientId = selectedId;
      } finally {
        this.loadingClients = false;
      }
    },
    myGroups() {
      this.loading = false;
      usersService.getUserGroupList(this.selectedUserId).then((result) => {
        this.mygroups = result;
        this.loading = true;
      });
    },
    deleteMember(team_user_id) {
      usersService.deleteMember(team_user_id).then((result) => {
        this.$emit("getUser");
        this.myGroups();
      });
    },
    trialEnd() {
      if (this.selected.client.trial_period_ended != "-1") {
        return this.selected.client.trial_period_ended === true;
      }
      return this.selected.client.trial_period_ended;
    },
    getFinishDate() {
      let dateinit = this.selected.client.creation_date;
      dateinit = dateinit.split("-");
      let result = new Date(
        dateinit[0] + "-" + dateinit[1] + "-" + dateinit[2]
      );
      let trialdays;
      if (this.selected.client.trial_days != "-1") {
        trialdays = parseInt(this.selected.client.trial_days);
      } else {
        trialdays = parseInt(this.selected.client.trial_days);
      }
      if (isNaN(trialdays)) trialdays = 0;

      return this.addDays(result, trialdays).toLocaleDateString();
    },
    addDays(date, days) {
      const copy = new Date(Number(date));
      copy.setDate(date.getDate() + days);
      return copy;
    },
    getRole(id) {
      if (id == 1) {
        return "Member";
      }
      if (id == 2) {
        return "Project manager";
      }
      if (id == 3) {
        return "Viewer";
      }
    },
    selectGroup() {
      if (this.group) {
        this.groupnew = "";
      }
    },
    approveVerification() {
      this.active = true;
      usersService.verificationCodeAdmin(this.selected.user.id);
    },
    unBlock() {
      usersService
        .unBlock(this.selected.user.id)
        .then((result) => {
          if (result != false) {
            this.selected.user.login_attempt = 0;
          }
        })
        .catch((err) => {
          console.log(
            "Ha ocurrido un error, no se puede realizar la operacion"
          );
        });
    },
    saveUserClientDetail() {

      if (this.groupnew) {
        this.group = this.groupnew;
      }
      let params = {
        fee_per_client: this.feeClient,
        revenue_share: this.renueShare,
        affiliate_comp_type: this.affiliateCompType,
        commission_time: this.timeComission,
        user_id: this.selectedUserId,
        role_id: this.selected.user.role_id,
        calendar_link: this.selected.user.calendar_link,
        landing_link: this.selected.user.landing_link,
        calendly: this.selected.user.calendly,
        group: this.group,
        group_role: this.group_role,
      };
      if (this.hasPermissions("superAdmin") && this.selectedClientId) {
        params.client_id = this.selectedClientId;
      }
      usersService.saveUserClientDetail(params).then(() => {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.label.datasavedsuccessfully"),
          showConfirmButton: false,
          timer: 5000,
        });
      }).then(() => {
        this.groupnew = "";
        this.$emit("getUser");
        this.myGroups();
      })
    }
  }
};
</script>

<style scoped>
.user-client-select >>> .vue-treeselect {
  font-size: 0.8rem;
}

.user-client-select >>> .vue-treeselect__control {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  min-height: calc(1.5em + 0.75rem + 2px);
  background-color: #fff;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.user-client-select >>> .vue-treeselect__control:hover {
  border-color: #adb5bd;
}

.user-client-select >>> .vue-treeselect--focused .vue-treeselect__control {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.user-client-select >>> .vue-treeselect__placeholder,
.user-client-select >>> .vue-treeselect__single-value,
.user-client-select >>> .vue-treeselect__input-container {
  font-size: 0.8rem;
  line-height: 1.5;
}

.user-client-select >>> .vue-treeselect__menu {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  z-index: 1050;
}

.user-client-select__spinner {
  position: absolute;
  top: 50%;
  right: 10px;
  width: 15px;
  height: 15px;
  margin-top: -7px;
  z-index: 2;
}
</style>
